export function drawCurvedLine(
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  color: string,
  ctx: CanvasRenderingContext2D
) {
  const midX = (x1 + x2) / 2
  const midY = (y1 + y2) / 2
  const controlX = midX + (y2 - y1) / 4
  const controlY = midY - (x2 - x1) / 4

  ctx.beginPath()
  ctx.moveTo(x1, y1)
  ctx.quadraticCurveTo(controlX, controlY, x2, y2)
  ctx.strokeStyle = color
  ctx.lineWidth = 3
  ctx.stroke()
}
